import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays, formatDistance, formatDistanceToNow, parseISO, isToday, isYesterday, format } from 'date-fns';

@Pipe({
  name: 'relativeDate',
  standalone: true
})
export class RelativeDatePipe implements PipeTransform {

  transform(value: string | Date): string {
    if (!value) return '';

    // Parse the input date
    const date = typeof value === 'string' ? parseISO(value) : value;

    try {

      let dateCheck = new Date(date);
      if (isNaN(dateCheck.getTime()) || dateCheck.getFullYear() < 1900 || (dateCheck.getFullYear() === 1900 && dateCheck.getMonth() === 0 && dateCheck.getDate() === 1)) {
        return '-';
      }
      // Get the current UTC time
      let cDate = new Date().toISOString(); // 2025-03-27T09:37:55.726Z

      const nowUTC = parseISO(cDate.split('.')[0]); // remove  .726Z from the date

      //just now 

      if (formatDistance(date, nowUTC, { addSuffix: true }) === 'less than a minute ago') {
        return format(date, 'HH:mm') +' (Just now)';
      }
      // Check if the date is today in UTC
      if (isToday(date)) {
        return format(date, 'HH:mm') + ` (${formatDistance(date, nowUTC, { addSuffix: true })})`;
      }
      //yesterday
      else if (isYesterday(date)) {
        return format(date, 'dd MMM') + ' (Yesterday)';
      }
      // Check if the date is within the last 10 days
      else if (differenceInDays(nowUTC, date) <= 10) {
        return format(date, 'dd MMM') + ` (${formatDistance(date, nowUTC, { addSuffix: true })})`;
      }
      // Check if the date is within the same year
      else if (date.getUTCFullYear() === nowUTC.getUTCFullYear()) {
        return format(date, 'dd MMM');
      }
      // Otherwise, return the full date in UTC
      else {
        return format(date, 'yyyy-MM-dd');
      }
    } catch (error) {
      console.error('Error in RelativeDatePipe', error);
      return '';
    }
  }
}